<template>
  <div class="ugo-form-field">
  <FormViewItem v-if="as_view" :label="label" :required="!!required">
    <span class="ugo-form-view-text" :class="{ 'ugo-form-view-empty': isEmptyViewValue(value) }">{{ viewDisplayText }}</span>
  </FormViewItem>
  <FormItem v-else :label="label" :required="!!required" :prop="fkey">
    <BaseTagsInput
      v-model="_value"
      :disabled="!editable"
      clearable
      placeholder="请输入(回车创建标签)"
      v-bind="config || {}"
      :style="`width:${config?.width || 200}px`"
      />
  </FormItem>
  </div>
</template>

<script>
import defaultValueMixin from '../mixins/default-value';
import valueDefMixin from '../mixins/value-def';
import asViewMixin, { EMPTY_VIEW_TEXT } from '../mixins/as-view';
import {buildValueDef} from '../value-def-helpers';
export default {
  mixins: [defaultValueMixin, valueDefMixin, asViewMixin],
  methods: {
    getValueDef() {
      return buildValueDef({
        type: 'array',
        key: this.fkey,
        name: this.label,
        option: {description: '标签字符串数组', ...(this.config || {})},
      });
    },
  },
  cname: '标签输入',
  corder: 13,
  props: ['value', 'label', 'fkey', 'required', 'config', 'editable', 'old'],
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
    viewDisplayText() {
      if (!Array.isArray(this.value) || this.value.length === 0) {
        return EMPTY_VIEW_TEXT;
      }
      return this.value.join('、');
    },
  },
  properties: [
    {
      label: '字数限制',
      key: 'maxlen',
      control: 'Text',
    },
    {
      label: '宽度',
      key: 'width',
      control: 'Text',
    },

  ],
};
</script>

<style lang="less" scoped>

</style>
